<style scoped>
    .mainBox{
        margin-top: .16rem;
        background: #fff;
        padding: 0 .38rem;
    }
    .itemBox{
        /*margin-top: .16rem;*/
        height: 1.12rem;
        display: flex;
        align-items: center;
        background: #fff;
        border-bottom: .02rem solid #F0F0F0;
    }
    .itemBox:last-child{
        border-bottom: 0;
    }

    .name{
        width: 1.2rem;
        font-size: .28rem;
        color: #4D4D4D;
        margin-right: .9rem;
    }
    input{
        width: 2.88rem;
        border: none;
        font-size: .28rem;
        color: #333;
    }
    input::placeholder{
        color: #ccc;
    }
    input:disabled{
        background: #fff;
    }
    .send{
        width: 1.6rem;
        height: .64rem;
        background: #408BFB;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: .24rem;
        color: #fff;
        border-radius: .32rem;
        margin-left: .1rem;
    }
    .btn{
        width: 6.74rem;
        height: .88rem;
        border-radius: .44rem;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: .28rem;
        color: #fff;
        font-weight: bold;
        margin: 1.5rem auto 0;
        background: #408BFB;
        position: fixed;
        left: 0;
        right: 0;
        bottom: .38rem;
    }
</style>
<template>
    <div style="padding-top: .98rem">
        <topbar text="修改手机号"></topbar>
        <div class="mainBox">
            <div class="itemBox">
                <div class="name">新手机号</div>
                <input type="text" placeholder="请输入新手机号码" v-model="userPhone">
            </div>
            <div class="itemBox">
                <div class="name">验证码</div>
                <input type="text" placeholder="请输入手机验证码" v-model="code">
                <div class="send" v-if="status===0" @click="getSmsAuthCode">获取验证码</div>
                <div class="send" v-if="status===1">{{num}}</div>
                <div class="send" v-if="status===2" @click="getSmsAuthCode">重新获取</div>
            </div>
        </div>

        <div class="btn" @click="sure">确定</div>
    </div>
</template>
<script>
    import {getSource, getSources} from "../api"

    import noMoreData from 'components/no-more-data'
    import topbar from 'components/topbar'
    import moment from 'moment/moment'

    import {serialize} from 'utils/index'

    export default {
        data() {
            return {
//                EnvUrl: `https://oml9ntix5.qnssl.com/`, // 七牛图片
                EnvUrl: `https://cdn.ysqingxin.com/`,
                num: 59,
                status: 0,
                userPhone: '',
                code:''
            }
        },
        components: {
            noMoreData,
            topbar,
        },
        filters: {

            time(value) {
                let transTime = moment(value).format('YYYY-MM-DD HH:mm:ss')
                return transTime
            },
        },
        computed: {},
        methods: {
            sure(){
                if(!this.userPhone){
                    alert('请输入手机号')
                }else if(!this.code){
                    alert(`请输入验证码`)
                }else{
                    this.completeScaleUserInfo()
                }
            },
            signOut(){
                localStorage.removeItem('doctorId')
                localStorage.removeItem('doctorName')

                if(!localStorage.getItem('doctorId')){
                    this.$router.push(`/login`)
                }else{
                    setTimeout(()=>{
                        this.$router.push(`/login`)
                    },200)
                }
            },
            async completeScaleUserInfo() {
                let data = await getSources("/bear-scale/api/scaleUserInfo/completeScaleUserInfo.json",{userId:localStorage.getItem('userId'),userPhone:this.userPhone,code:this.code});
                if (data.status === 0) {
                    // this.signOut();
                    localStorage.setItem('userPhone',data.scaleUser.userPhone);
                    alert('修改成功')
                    history.back()
                }else{
                    alert(data.msg)
                }
            },
            async getSmsAuthCode() {
                if(!this.userPhone){
                    alert('请先输入手机号')
                    return
                }
                let data = await getSources("/bear-scale/api/scaleUserInfo/getSmsAuthCode.json",{userPhone:this.userPhone});
                if (data.status === 0) {
                    alert('发送成功')
                    this.status = 1
                    this.num = 59

                    // this.$nextTick(() => {
                    // 	this.$refs.code.focus()
                    // })

                    const that = this

                    setTimeout(function codeFormat() {
                        that.num--

                        if (that.num) {
                            setTimeout(codeFormat, 1000)
                        } else {
                            that.status = 2
                        }
                    }, 1000)


                    return
                }else{
                    alert(data.msg)
                }
            },
        },
        destroyed(){

        },
        mounted() {

        }
    }
</script>



// WEBPACK FOOTER //
// src/components/changePhone.vue?6f6dee60